import React, { FC } from 'react';
import { LeftOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import { Gender, LabelType } from '@/enum';
import { url } from '@/url';

import styles from './index.module.less';
import { useAccountInfo } from '@/store/account';
import { useAccountLabelInfo } from '@/store/account-label-info';
import { useUrlQueryState } from '@@/react-hooks';
import { LabelerURLQuery } from '@/interface/url';

export const LabelLayout: FC = ({ children }) => <div className={styles.layout}>{children}</div>;

export const LabelLayoutHeader: FC<{
  gender: Gender;
  c1: string;
  c2: string;
  type: LabelType;
}> = ({ children, gender, c1, c2, type }) => {
  const { username } = useAccountInfo();

  const [labelInfo] = useAccountLabelInfo();

  const [{ labeler }] = useUrlQueryState<LabelerURLQuery>();

  return (
    <header className={styles.header}>
      <Link className={styles.link} to={url.home()}>
        <LeftOutlined /> 返回首页
      </Link>
      <span className={styles.info}>
        类别：{gender} / {c1} / {c2}
      </span>
      <span className={styles.info}>账号：{username}</span>
      {labeler ? <span className={styles.info}>指定标注账号：{labeler}</span> : null}
      {
        type === LabelType.Classify ? labelInfo.labeler ? (
          <span className={styles.info}>已标注：{labelInfo.labeledCount}</span>
        ) : null : labelInfo.verifier ? (
          <span className={styles.info}>已审核：{labelInfo.verifiedCount}</span>
        ) : null
      }
      <span className={styles.spaceholder} />
      {children}
    </header>
  );
};
